import ajaxLogin from './ajaxLogin';

export default ajaxLogin;
